import {
  SocialButton
} from "../chunk-TY4DM4QD.mjs";
import "../chunk-7CU25RIV.mjs";

// src/social-buttons/social-button-apple.tsx
import * as React from "react";
import { systemForwardRef } from "@stepstone-genesis/system";
import { AppleLoginColouredIcon } from "@stepstone-genesis/icons";
var SocialAppleButton = systemForwardRef(
  function SocialAppleButton2({ children, ...props }, ref) {
    var _a;
    const defaultLabel = "Log in with Apple";
    return /* @__PURE__ */ React.createElement(
      SocialButton,
      {
        ref,
        element: "SOCIAL_APPLE_BUTTON",
        ...props,
        iconBefore: /* @__PURE__ */ React.createElement(AppleLoginColouredIcon, null),
        a11yLabel: (_a = props.a11yLabel) != null ? _a : defaultLabel
      },
      children != null ? children : defaultLabel
    );
  }
);
export {
  SocialAppleButton
};
